import React from "react";
import PageTemplate from "./../ui/page_template";
import {Route} from "react-router-dom";
import Basic from "./basic";
import IdentityDocument from "./identity_document";
import Education from "./education";
import EgeResults from "./ege_results";
import EgeDocuments from "./ege_documents";
import Achievements from "./achievements";
import Privileges from "./privileges";
import OtherDocuments from "./other_documents";
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const Profile = ({ match }) => {
    const { t } = useTranslation();
    return (
        <PageTemplate title={t('my_profile')}>
            <Grid container spacing={2} className="profile">
                <Grid item xs={12}>
                    <Route exact path="/profile" component={Basic} />
                    <Route path="/profile/identity" component={IdentityDocument} />
                    <Route path="/profile/education" component={Education} />
                    <Route path="/profile/ege-results" component={EgeResults} />
                    <Route path="/profile/ege-documents" component={EgeDocuments} />
                    <Route path="/profile/achievements" component={Achievements} />
                    <Route path="/profile/privileges" component={Privileges} />
                    <Route path="/profile/other-documents" component={OtherDocuments} />
                </Grid>
            </Grid>
        </PageTemplate>
    );
};

export default Profile;
